import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import IvrSpeciesData from "../../json/IvrSpecies.json";

function getSelectValue(value) {
  console.log("Selected", value);
  if (!value || Object.keys(value).length !== 2) return null;

  return { label: value.name, id: value.id };
}

function IvrSpecies({ id, name, value, onChange }) {
  const getSpecies = () => {
    let speciesList = [];

    IvrSpeciesData.sort((a, b) =>
      a.SPECIES_NAME.localeCompare(b.SPECIES_NAME)
    ).map(({ SPECIESCD, SPECIES_NAME }) =>
      speciesList.push({
        id: SPECIESCD,
        label: SPECIES_NAME,
      })
    );
    return speciesList;
  };
  const selectedValue = getSelectValue(value);
  const styles = {
    maxWidth: window.innerWidth < 750 ? "90%" : "350px",
    minWidth: window.innerWidth < 750 ? "90%" : "250px",
  };
  // Added to avoid case sensitive issues with the search
  const filterOptions = createFilterOptions({
    ignoreCase: true,
  });

  return (
    <Autocomplete
      id={id}
      name={name}
      options={getSpecies()}
      getOptionLabel={(option) => option.label}
      onChange={onChange}
      value={selectedValue}
      isOptionEqualToValue={(option) => option.id}
      style={styles}
      renderInput={(params) => (
        <TextField {...params} name={name} label="Species" variant="standard" />
      )}
      filterOptions={filterOptions}
    />
  );
}

export default IvrSpecies;
